import React from 'react';

import FeatureGuideFrontDeskList from './components/FeatureGuideFrontDeskList';

const FeatureGuide = () => <FeatureGuideFrontDeskList />;

export default FeatureGuide;
